import { Component, OnInit } from '@angular/core';
import { WorkflowPageNavigationService } from '../../../service/workflow-page-navigation/workflow-page-navigation.service';
import { WorkflowWidgetEventServiceService } from '../../../widget/workflow-widget-event.service';
import { PageElementBaseComponent } from './page-element-base.component';

@Component({ template: '', standalone: false })
/** Base Component Class for page elements */
export class CorePageBaseComponent extends PageElementBaseComponent implements OnInit {
  constructor(
    public workflowPageNavigationService: WorkflowPageNavigationService,
    public readonly widgetEventService: WorkflowWidgetEventServiceService
  ) {
    super();
  }
  ngOnInit(): void {
    this.page.onLoad();
    this.flow.onPageLoad();
    this.workflowPageNavigationService.updateNavState(this.page, true);
    this.workflowPageNavigationService.reset();
  }
}
